import React, { useRef, useState, useEffect } from 'react'

import Slider from 'components/slider/slider'

import { connect } from 'react-redux'
import {
    getCurrentUser,
    getCurrentAccount,
} from 'state/selectors'

import {
    validateCoupon
} from 'state/actions'

import User from 'components/auth/register-modal/user'
import Join from 'components/auth/register-modal/join'
import Account from 'components/auth/register-modal/account'
import Billing from 'components/auth/register-modal/billing'
import Invite from 'components/auth/register-modal/invite'

import { withRouter } from 'react-router'

import { Elements, StripeProvider } from 'react-stripe-elements'

import { environmentIndex } from 'env'
import { getUrlParams } from 'utils/text'

import {
    isMobile,
} from 'utils'

const ModalRegister = ({
    closeCallback,
    history,
    userData,
    accountData,
    pendingInvitation,
    allAccounts,
    data,
    validateCoupon
}) => {
    const _isMobile = isMobile()

    const sliderRef = useRef(null)
    const [hasMounted, setHasMounted] = useState(false) // Cause transitions inexplicably break
    const [activeStep, setActiveStep] = useState(0)
    const [hasMountedWithDelay, setHasMountedWithDelay] = useState(false)
    const [validatedStepIndex, setValidatedStepIndex] = useState(0)
    const [loginCredentials, setLoginCredentials] = useState(null)
    const [appSumoUsers, setAppSumoUsers] = useState(null)
    const [appSumoCode, setAppSumoCode] = useState(null)

    const currentUserRef = useRef(userData)
    currentUserRef.current = userData

    const allAccountsRef = useRef(allAccounts)
    allAccountsRef.current = allAccounts

    const [validInvitation, setValidInvitation] = useState(null)
    const [invitationError, setInvitationError] = useState(null)

    const activeStepRef = useRef(activeStep)

    activeStepRef.current = activeStep

    const { isSecondaryAccount } = data

    useEffect(() => {
        const _appSumoCode = getUrlParams('appsumo')

        if(_appSumoCode){
            validateCoupon(_appSumoCode, response => {
                if(response.lifetime_amount){
                    if(response.lifetime_amount !== 'TAKEN'){
                        setAppSumoCode(_appSumoCode)
                    }
                    setAppSumoUsers(response.lifetime_amount)
                }
            })
        }

        setTimeout(() => {
            setHasMounted(true)

            setTimeout(() => {
                setHasMountedWithDelay(true)
            }, 100)
        }, 1)

        if (pendingInvitation) {
            switch (pendingInvitation) {
                case 'TAKEN':
                case 'NONE':
                    setInvitationError(pendingInvitation)
                    break
                default:
                    if(pendingInvitation.account && pendingInvitation.account.name){
                        setValidInvitation(pendingInvitation)
                    }else{
                        setInvitationError('NONE')
                    }
                    break
            }
        }

        if (isSecondaryAccount) {
            setTimeout(() => {
                setStep(2)
            }, 100)
        } else {
            setTimeout(() => {
                if (accountData && userData) {
                    setValidatedStepIndex(2)
                    setStep(3)
                } else if (userData) {
                    setValidatedStepIndex(1)
                    setStep((userData.authorisedAccount || userData.invitedAccount) ? 1 : 2)
                }
            }, 2000)
        }
    }, [])

    const handleBackToLogin = e => {
        e.preventDefault()
        e.stopPropagation()

        history.push(`/auth/login`)
        closeCallback()
    }

    const keys = [
        'pk_test_cAKKfcpav5trEkMSrBXq3A8P00UM8VYpeR',
        'pk_live_LyD6BI6rDUiy9vW8eT0Y70H500iMTPgA44'
    ]

    let keyIndex = 1

    if (!environmentIndex) {
        keyIndex = 0
    }

    const steps = [
        {
            title: (() => {
                if(validInvitation && validInvitation.account && validInvitation.account.name){
                    return `Joining ${validInvitation.account.name}?`
                }

                if(appSumoUsers){
                    return `Hey Sumo-ling!`
                }

                return 'You must be new here.'
            })(),
            body: (() => {
                if(validInvitation){
                    return `Pop in your details, and we'll add you to their account.`
                }

                if(appSumoUsers){
                    if(appSumoUsers === 'TAKEN'){
                        return `This coupon code has been used already. Create an organization anyway?`
                    }

                    return `Your lifetime account for ${ appSumoUsers } users is waiting 😊.<br />Pop in your details to get going.`
                }

                return `Welcome to Hassl. We're so glad to have you.`
            })(),
            component: User,
            background: {
                bigBg: 'bg-1.jpg',
                image: `step-1.png`,
            }
        }, {
            title: `Join this organization?`,
            body: (userData && userData.authorisedAccount) ? `<em>${userData.authorisedAccount.name}</em> has authorized your email to join their organization.` : (userData && userData.invitedAccount) ? `You have a pending invitation to <em>${userData.invitedAccount.name}</em>.` : null,
            component: Join,
            background: {
                image: `join.png`,
                title: `Great news! Your team's already here.`,
                body: `Head straight in - we'll skip the rest of your registration.`,
                bigBg: 'bg-1.jpg'
            },
            hideDot: true
        },
        {
            title: isSecondaryAccount ? `Add another organization` : 'Create an organization',
            body: isSecondaryAccount ? `You'll be able to switch at any point.` : `This'll contain all your projects and files. You can add more organizations once you're all set up.`,
            component: Account,
            background: {
                bigBg: 'bg-2.jpg',
                image: `step-2.png`,
            }
        },
        {
            title: 'Add payment details?',
            body: isSecondaryAccount ? `Optional - you won't be billed until your trial ends 😊.` : `Pop 'em in now for an extra 2 MONTHS free<br />on top of your 30-day trial.`,
            component: Billing,
            background: {
                bigBg: 'bg-1.jpg',
                image: `step-3.png`,
            }
        },
        {
            title: `You're in!`,
            body: (() => {
                if(accountData && accountData.lifetime_amount){
                    return `Congrats on your lifetime deal. Choose ${ accountData.lifetime_amount - 1 } other users to invite (for free!). You can do this step later, if you'd prefer.`
                }else{
                    return `Let's get this party started. Invite the rest of your team.`
                }
            })(),
            component: Invite,
            background: null,
            hideDot: true
        },
    ]

    const setStep = type => {
        let currentIndex = activeStepRef.current

        let newIndex = null

        switch (type) {
            case 'next':
                newIndex = currentIndex + 1
                break
            case 'prev':
                newIndex = currentIndex - 1
                break
            default:
                newIndex = type
                break
        }

        setActiveStep(newIndex)

        sliderRef.current.select(newIndex)
    }

    const refreshSlider = () => {
        setTimeout(() => {
            window.requestAnimationFrame(() => {
                if (sliderRef.current) {
                    sliderRef.current.resize()
                }
            })
        }, 2)
    }

    const _setLoginCredentials = (email, password) => {
        setLoginCredentials({
            email,
            password
        })
    }

    const goToDashboard = _ => {
        const { current: _allAccounts } = allAccountsRef

        const lastSeenAccount = _allAccounts[currentUserRef.current.last_open_account_id]

        if (lastSeenAccount) {
            history.push('/' + lastSeenAccount.slug)
        }else{
            history.push('/')
        }
        
        closeCallback()
    }

    if (!hasMounted) {
        return null
    }

    const dotsHidden = (() => {
        if(steps[activeStep] && steps[activeStep].hideDot){
            return true
        }

        if(validInvitation){
            return true
        }
    })()

    return (
        <StripeProvider apiKey={keys[keyIndex]}>
            <Elements>
                <React.Fragment>
                    <div className={`register-modal ${hasMountedWithDelay ? 'visible' : ''}`}>
                        <div className="scroll-container">
                            <div className={'register-inner'}>
                                <img
                                    src={document.base + "/images/logo.png"}
                                    className="logo"
                                />
                                <ul>
                                    <Slider
                                        className={'steps-slider'}
                                        options={{
                                            prevNextButtons: false,
                                            pageDots: false,
                                            adaptiveHeight: true,
                                            cellAlign: 'center',
                                            draggable: false,
                                        }}
                                        flickityRef={ref => sliderRef.current = ref}
                                    >
                                        {steps.map((step, index) => {
                                            const {
                                                title,
                                                body,
                                                component: Component
                                            } = step

                                            const isActiveStep = activeStepRef.current === index

                                            return (
                                                <li className={'step'} key={index}>
                                                    <h1>
                                                        {title}
                                                    </h1>
                                                    <span className="heading-subtitle" dangerouslySetInnerHTML={{ __html: body }} />
                                                    <Component
                                                        setStep={setStep}
                                                        refreshSlider={refreshSlider}
                                                        isActiveStep={isActiveStep}
                                                        setLoginCredentials={_setLoginCredentials}
                                                        loginCredentials={loginCredentials}
                                                        closeCallback={closeCallback}
                                                        handleBackToLogin={handleBackToLogin}
                                                        handleGoToDashboard={goToDashboard}
                                                        invitation={validInvitation}
                                                        invitationError={invitationError}
                                                        isSecondaryAccount={isSecondaryAccount}
                                                        appSumoUsers={appSumoUsers}
                                                        appSumoCode={appSumoCode}
                                                    />
                                                </li>
                                            )
                                        })}
                                    </Slider>
                                    <div className={`dots ${dotsHidden ? 'hidden' : ''}`}>
                                        {steps.map((step, index) => {
                                            const {
                                                hideDot
                                            } = step

                                            if (hideDot) {
                                                return null
                                            }

                                            const isDisabled = validatedStepIndex < index

                                            return (
                                                <div
                                                    className={`${activeStep === index ? 'active' : ''} ${isDisabled ? 'disabled' : ''}`}
                                                    key={index}
                                                    onClick={() => {
                                                        if (!isDisabled) {
                                                            setStep(index)
                                                        }
                                                    }}
                                                />
                                            )
                                        })}
                                    </div>
                                </ul>
                            </div>
                        </div>
                        {(!_isMobile && !isSecondaryAccount) ?
                            <div className={`register-bg ${steps[activeStep] && steps[activeStep].background ? 'has-background' : ''}`}>
                                <ul className={'background'}>
                                    { steps.map((step, index) => {
                                        const { background } = step

                                        return (
                                            <li 
                                                key={index} 
                                                style={{
                                                    backgroundImage: (background && background.bigBg) ? `url(${document.base}/images/registration/${ background.bigBg })` : ''
                                                }}
                                                className={activeStep === index ? 'active' : ''}
                                            />
                                        )

                                    })}
                                </ul>
                                <ul className={'foreground'}>
                                    {steps.map((step, index) => {
                                        const {
                                            background
                                        } = step

                                        if (!background || !background.image) {
                                            return (
                                                <li key={index} />
                                            )
                                        }

                                        const {
                                            image,
                                            title,
                                            body
                                        } = background

                                        return (
                                            <li
                                                key={index}
                                                className={activeStep === index ? 'active' : ''}
                                            >
                                                <img src={`${document.base}/images/registration/${image}`} />
                                            </li>
                                        )
                                    })}
                                </ul>
                            </div>
                            : null}
                    </div>
                </React.Fragment>
            </Elements>
        </StripeProvider>
    )
}

const mapStateToProps = state => {
    return {
        userData: getCurrentUser(state, true),
        accountData: getCurrentAccount(state),
        pendingInvitation: state.auth.pendingInvitation,
        allAccounts: state.account.entities ? state.account.entities.accounts : null,
    }
}

export default withRouter(connect(mapStateToProps, {
    validateCoupon
})(ModalRegister))


// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-register.jsx